export default "__VITE_ASSET__ifSo02Yl__"